function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { ChevronRightIcon, ChevronLeftIcon } from '@domain-group/fe-co-icon';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { AgencyCard, AgencyCardOld } from '@domain-group/fe-co-allhomes-shared-components';
import { MixpanelLabels } from '../../analytics/constants';
import * as styles from './agencies.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Agencies = _ref => {
  var _agencyList$nodes, _agencyList$nodes3;
  var localityName = _ref.localityName,
    agencySearchSlug = _ref.agencySearchSlug,
    agencyList = _ref.agencyList,
    enquiryEndpoint = _ref.enquiryEndpoint;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl,
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibilityEventSent = _useState2[0],
    setVisibilityEventSent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    leftScrollButtonVisible = _useState4[0],
    setLeftScrollButtonVisible = _useState4[1];
  var _useState5 = useState((agencyList === null || agencyList === void 0 ? void 0 : (_agencyList$nodes = agencyList.nodes) === null || _agencyList$nodes === void 0 ? void 0 : _agencyList$nodes.length) > 1),
    _useState6 = _slicedToArray(_useState5, 2),
    rightScrollButtonVisible = _useState6[0],
    setRightScrollButtonVisible = _useState6[1];
  var startOfCardsRef = useRef();
  var endOfCardsRef = useRef();
  var agencyCount = (agencyList === null || agencyList === void 0 ? void 0 : agencyList.total) || 0;
  var viewAllLink = "/agents/results/".concat(agencySearchSlug);
  var handleVisibility = isVisible => {
    if (isVisible && !visibilityEventSent) {
      sendEvent('display-appraisal-cta', {
        interactionCTA: MixpanelLabels.SOLD_AGENCY_CARDS
      });
      setVisibilityEventSent(true);
    }
  };
  var AgencyCardComponent = toggledFeatures[ToggledFeatureKey.AGENCY_BRANDING] ? AgencyCard : AgencyCardOld;
  return ___EmotionJSX(Fragment, null, agencyCount > 0 && ___EmotionJSX("div", {
    css: styles.agencies
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, "".concat(agencyCount, " real estate agenc").concat(agencyCount === 1 ? 'y' : 'ies', " active in ").concat(localityName)), ___EmotionJSX("div", {
    css: styles.subHeading
  }, "Thinking of selling? Compare agencies with experience in Canberra."), ___EmotionJSX(VisibilitySensor, {
    onChange: handleVisibility
  }, ___EmotionJSX("div", {
    css: styles.cardsContainer
  }, ___EmotionJSX("button", {
    "aria-label": "previous",
    type: "button",
    css: styles.scrollBtnLeft,
    style: {
      opacity: leftScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      startOfCardsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  }, ___EmotionJSX(ChevronLeftIcon, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })), ___EmotionJSX("div", {
    css: styles.cardList,
    onScroll: evt => {
      var _agencyList$nodes2;
      setLeftScrollButtonVisible(evt.target.scrollLeft > 10);
      setRightScrollButtonVisible((agencyList === null || agencyList === void 0 ? void 0 : (_agencyList$nodes2 = agencyList.nodes) === null || _agencyList$nodes2 === void 0 ? void 0 : _agencyList$nodes2.length) > 1 && evt.target.scrollLeft <= evt.target.scrollWidth - evt.target.clientWidth - 10);
    }
  }, ___EmotionJSX("div", {
    ref: startOfCardsRef
  }), agencyList === null || agencyList === void 0 ? void 0 : (_agencyList$nodes3 = agencyList.nodes) === null || _agencyList$nodes3 === void 0 ? void 0 : _agencyList$nodes3.map((_ref2, index) => {
    var agency = _ref2.agency;
    return ___EmotionJSX("div", {
      css: styles.card
    }, ___EmotionJSX(AgencyCardComponent, {
      key: agency.agencyId,
      index: index,
      enquiryEndpoint: enquiryEndpoint,
      results: agencyList,
      onAppraisalClick: () => {
        sendEvent('request-a-free-appraisal-click', {
          enquiryCTA: MixpanelLabels.SOLD_AGENCY_CARDS
        });
      },
      emailButtonLabel: "Email"
    }));
  }), ___EmotionJSX("div", {
    ref: endOfCardsRef
  })), ___EmotionJSX("button", {
    "aria-label": "next",
    type: "button",
    css: styles.scrollBtnRight,
    style: {
      opacity: rightScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      endOfCardsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  }, ___EmotionJSX(ChevronRightIcon, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })))), agencyCount > 3 && ___EmotionJSX(LinkButton, {
    css: styles.viewAllLink,
    href: getAbsoluteUrl(viewAllLink),
    appearance: "outline",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "View all agencies")));
};
Agencies.propTypes = {
  localityName: PropTypes.string.isRequired,
  agencySearchSlug: PropTypes.string.isRequired,
  agencyList: PropTypes.shape({
    total: PropTypes.number,
    nodes: PropTypes.arrayOf(PropTypes.shape({
      agency: PropTypes.shape({
        agencyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      }),
      stats: PropTypes.shape({})
    }))
  }),
  enquiryEndpoint: PropTypes.string.isRequired
};
Agencies.defaultProps = {
  agencyList: []
};
export default withEventBoundary('agencies')(Agencies);